import {call, put} from 'redux-saga/effects';
import LanguageActions from '../redux/LanguageRedux';
import i18n from 'i18next';

const LANGUAGE_STORAGE_KEY = 'currentLanguage';

export function * changeLanguage(authApi, api, action) {
  const {id} = action;
  i18n.changeLanguage(id);
  localStorage.setItem(LANGUAGE_STORAGE_KEY, JSON.stringify(id));
  yield call(authApi.setLanguage, id);
  yield call(api.setLanguage, id);

  yield put(LanguageActions.languageSuccess(id));
}

export function * getLanguage() {
  const id = JSON.parse(localStorage.getItem(LANGUAGE_STORAGE_KEY));
  if (id != null) {
    yield put(LanguageActions.languageChangeRequest(id));
  } else {
    const lng = i18n.language || window.localStorage.i18nextLng || 'ru';
    yield put(LanguageActions.languageChangeRequest(lng));
  }
}
